import enAU from "./en-AU.json";
import enNZ from "./en-NZ.json";
import enUS from "./en-US.json";
import frCA from "./fr-CA.json";

export default { enAU, enNZ, enUS, frCA };
